<template>

    <static-vanilla :page="pageName"></static-vanilla>

</template>

<script>
import UserFlow from '@/modules/userFlow'

import StaticVanilla from '@/components/StaticVanilla'

export default {

    name: 'impressum',

    components: {StaticVanilla},

    data () {
        return  {
            pageName: 'impressum'
        }
    },

    mounted() {
        UserFlow.setPage(this, this.pageName)
    }
}
</script>